"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInput = exports.CheckboxInput = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../theme/colors");
function CheckboxInput(_a) {
    var indeterminate = _a.indeterminate, checked = _a.checked, props = (0, tslib_1.__rest)(_a, ["indeterminate", "checked"]);
    var inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        inputRef.current.indeterminate = checked ? false : indeterminate;
    }, [indeterminate, checked]);
    return (react_1.default.createElement(exports.StyledInput, (0, tslib_1.__assign)({}, props, { type: "checkbox", ref: inputRef, checked: checked, readOnly: !props.onChange, "data-testid": "".concat(props.testId, "-checkbox") })));
}
exports.CheckboxInput = CheckboxInput;
exports.StyledInput = styled_components_1.default.input({
    appearance: 'none',
    cursor: 'pointer',
    border: "1px solid ".concat(colors_1.colors.steel[200]),
    backgroundColor: '#fff',
    borderRadius: 6,
    boxSizing: 'border-box',
    display: 'inline-block',
    verticalAlign: 'top',
    outline: 'none',
    width: 20,
    height: 20,
    margin: 0,
    position: 'relative',
    transition: 'background-color .3s ease',
    ':checked': {
        backgroundColor: colors_1.colors.brand[400],
        borderColor: colors_1.colors.brand[400],
        '&:disabled': {
            backgroundColor: colors_1.colors.steel[200],
            borderColor: colors_1.colors.steel[200],
        },
        '&:after': {
            opacity: 1,
        },
    },
    ':disabled': {
        backgroundColor: colors_1.colors.steel[100],
        borderColor: colors_1.colors.steel[200],
        opacity: 0.6,
        cursor: 'not-allowed',
    },
    '&:focus': {
        boxShadow: "0 0 0 2px ".concat(colors_1.colors.brand[200]),
    },
    ':indeterminate': {
        borderColor: colors_1.colors.brand[400],
        boxShadow: "0 0 0 1px inset ".concat(colors_1.colors.brand[400]),
        '&:disabled': {
            boxShadow: "0 0 0 1px inset ".concat(colors_1.colors.steel[200]),
            borderColor: colors_1.colors.steel[200],
            '&:after': {
                backgroundColor: colors_1.colors.steel[200],
            },
        },
        '&:after': {
            opacity: 1,
            border: 0,
            width: 12,
            top: '50%',
            left: '50%',
            height: 2,
            borderRadius: 8,
            backgroundColor: colors_1.colors.brand[400],
            transform: 'translate(-50%, -50%)',
        },
    },
    '&:after': {
        boxSizing: 'border-box',
        width: 6,
        height: 11,
        border: '2px solid #fff',
        borderTop: 0,
        borderLeft: 0,
        left: 6,
        top: 2,
        transform: 'rotate(43deg)',
        content: '""',
        display: 'block',
        position: 'absolute',
        opacity: 0,
        transition: 'opacity .3s ease',
    },
});
//# sourceMappingURL=index.js.map